import { render } from "./ResidentSupervise.vue?vue&type=template&id=0232ada1&scoped=true"
import script from "./ResidentSupervise.vue?vue&type=script&lang=js"
export * from "./ResidentSupervise.vue?vue&type=script&lang=js"

import "./ResidentSupervise.vue?vue&type=style&index=0&id=0232ada1&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0232ada1"]])

export default __exports__